import { createContext } from "react";

export type DTHoverState = {
  hoveredColumnId: string | null;
  resizingColumnId: string | null;
};

export type DTHoverStartAction = {
  type: "HOVER_START";
  payload: {
    columnId: string;
  };
};

export type DTHoverEndAction = {
  type: "HOVER_END";
  payload: {
    columnId: string;
  };
};

export type DTResizeStartAction = {
  type: "RESIZE_START";
  payload: {
    columnId: string;
  };
};

export type DTResizeEndAction = {
  type: "RESIZE_END";
  payload: {
    columnId: string;
  };
};

export type DTHoverAction =
  | DTHoverStartAction
  | DTHoverEndAction
  | DTResizeStartAction
  | DTResizeEndAction;

export const DTHoverStateContext = createContext<DTHoverState>({
  hoveredColumnId: null,
  resizingColumnId: null,
});
export const DTHoverDispatchContext = createContext<
  React.Dispatch<DTHoverAction>
>(() => {});
